import TotalHeader from './TotalHeader';

export default TotalHeader;



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/Inventory/TotalHeader/index.tsx